//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export interface IVoteBallotProxyView
{
	proxyPreferenceAttendText: string;
	proxyPreferenceDirectedText: string;
	proxyPreferenceEmailLabel: string;
	proxyPreferenceNominateText: string;
	proxyPreferenceStatement: string;
}
export interface IVoterVoteView
{
	ballotOptionId: number;
	ballotOptionName: string;
	groupId: number;
	ibpsaGroup: string;
	isSubmitted: boolean;
	round?: number;
	score: number;
	textValue: string;
	voteWeight: number;
}
export interface IVoteVoterView
{
	email: string;
	guid: string;
	name: string;
	personalId: string;
	proxyDecision: VoterProxyDecision;
	proxyEmail: string;
	proxySubmitDate?: any;
	proxySubmitDateFormated: string;
	uniqueId: string;
	voteSubmitDate?: any;
	voteSubmitDateFormatted: string;
	voteWeight: number;
}
export interface IVoteBallotView
{
	ballotNotOpenStatement: string;
	ballotStatement: string;
	closeDateFormattedAbbrTz: string;
	groupVotingStatement: string;
	id: number;
	isAgm: boolean;
	isNominationBallot: boolean;
	isReceiptConfirmation: boolean;
	isSmsReceipt: boolean;
	isSplitVoting: boolean;
	isSubmitVotesEachGroup: boolean;
	isVoteChange: boolean;
	isVoteConfirmation: boolean;
	loginFormStatement: string;
	name: string;
	openDateUtc: any;
	orgLogo: string;
	orgName: string;
	passwordLabel: string;
	pauseMessage: string;
	personalIdLabel: string;
	uniqueIdLabel: string;
	voteCastStatement: string;
	voteChangedStatement: string;
}
export interface IBallotNominationView
{
	allowAddress: boolean;
	allowBiography: boolean;
	allowCategory: boolean;
	allowCustom1: boolean;
	allowCustom2: boolean;
	allowEmail: boolean;
	allowGroup: boolean;
	allowPhoneMobile: boolean;
	allowPhoneWork: boolean;
	allowPhoto: boolean;
	allowPosition: boolean;
	allowSeconderEmail: boolean;
	allowSeconderName: boolean;
	ballotId: number;
	categoryLabel: string;
	categoryOptions: string;
	custom1Label: string;
	custom2Label: string;
	groupLabel: string;
	groupOptions: string;
	isAcceptanceRequired: boolean;
	isAddressRequired: boolean;
	isBiographyRequired: boolean;
	isCategoryOptions: boolean;
	isCategoryRequired: boolean;
	isCustom1Required: boolean;
	isCustom2Required: boolean;
	isEmailRequired: boolean;
	isGroupOptions: boolean;
	isGroupRequired: boolean;
	isMultipleNominations: boolean;
	isPhoneMobileRequired: boolean;
	isPhoneWorkRequired: boolean;
	isPhotoRequired: boolean;
	isPositionRequired: boolean;
	isSeconderEmailRequired: boolean;
	isSeconderNameRequired: boolean;
	seconderEmailLabel: string;
	seconderNameLabel: string;
}
export interface IVoterNominationView
{
	ballotId: number;
	custom1: string;
	custom2: string;
	isAccepted: boolean;
	nominationId?: number;
	nomineeAddress: string;
	nomineeBio: string;
	nomineeCategory: string;
	nomineeEmail: string;
	nomineeGroup: string;
	nomineeName: string;
	nomineePhoneMobile: string;
	nomineePhoneWork: string;
	nomineePhotoId: string;
	nomineePosition: string;
	seconderEmail: string;
	seconderName: string;
	voterGuid: string;
}
export interface IApiResponseModel
{
	errorMessage: string;
	isSuccessful: boolean;
}
export interface IApiResponsePayloadModel<PAYLOAD> extends IApiResponseModel
{
	payload: PAYLOAD;
}
export enum VoterProxyDecision {
	NotDeclared = "NotDeclared",
	Attending = "Attending",
	Proxy = "Proxy",
	DirectedProxy = "DirectedProxy"
}
export enum VoteCategories {
	BallotSingle = "BallotSingle",
	RankedPref = "RankedPref",
	Questionnaire = "Questionnaire",
	IBPSA = "IBPSA",
	RankedQuotaPref = "RankedQuotaPref",
	BallotMulti = "BallotMulti",
	IBPSAProxy = "IBPSAProxy",
	RankedAPHA = "RankedAPHA",
	Nomination = "Nomination",
	Survey = "Survey",
	RankedBorda = "RankedBorda",
	RankedCompulsory = "RankedCompulsory",
	BallotMultiMajority = "BallotMultiMajority",
	ExhaustiveBallot = "ExhaustiveBallot",
	AGMMotion = "AGMMotion",
	SwimmingAustraliaResolution = "SwimmingAustraliaResolution",
	SwimmingAustraliaDirectors = "SwimmingAustraliaDirectors"
}
export enum VoterValidateResult {
	BallotOpen = "BallotOpen",
	BallotAgmOpen = "BallotAgmOpen",
	BallotAgmClosed = "BallotAgmClosed",
	BallotNotOpenYet = "BallotNotOpenYet",
	BallotPaused = "BallotPaused",
	BallotClosed = "BallotClosed",
	BallotNotAttending = "BallotNotAttending",
	ReceiptRequired = "ReceiptRequired",
	BallotNotPublished = "BallotNotPublished",
	VoteSubmitted = "VoteSubmitted",
	ReceiptInvalid = "ReceiptInvalid",
	PersonalIdRequired = "PersonalIdRequired",
	PersonalIdInvalid = "PersonalIdInvalid",
	ProxyOpen = "ProxyOpen",
	ProxySubmitted = "ProxySubmitted"
}
